.container {
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
}

.items {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
}

.item {
  display: flex;
  gap: 0.8rem;
  align-items: center;
}

.title {
  font-weight: 600;
  color: var(--color-grayscale-light-slate);
}

.text {
  font-size: 1.4rem;
  font-weight: 400;
  color: var(--color-grayscale-white);
}
